module.exports = __webpack_public_path__ + "media/gist.35ef4d4a.wav";